export default "__VITE_ASSET__d82k$LsR__"